module.exports = __webpack_public_path__ + "fonts/nunito-sans-v6-latin-700.42a0afad.eot";